import * as Enums from "../../../../../../../framework/enum.shared";

import { Application } from "../../../../../../../application";
import { GUID } from "./../../../../../../../framework/domain-entity/guid";
import { MortgageFireHKSectionSchema } from "./../schemas/mf-hk-section-schema";
import { MortgageFireHKTabSchema } from "./../schemas/mf-hk-tab-schema";
import { ProposalEntity } from "./../../../../../base/proposal-entity.model";
import { QuestionEntity } from "./../../../../../base/question-entity.model";
import { QuestionSection } from "./../../../../../base/question-section";
import { common } from "./../../../../../../../framework/utils/common";
import { MasterDataService } from "../../../../../../../services/master-data.service";

export class MortgageFireHongKongMasterQuestionSection extends QuestionSection {
  qs_master_brokerFirstName!: QuestionEntity | undefined;

  //Implementation Preferred Delivery Method
  qs_master_preferredDeliveryMethod!: QuestionEntity | undefined;
  qs_master_preferredDeliveryMethod_Email!: QuestionEntity | undefined;
  qs_master_preferredDeliveryMethod_MobileNo!: QuestionEntity | undefined;
  qs_master_preferredDeliveryMethod_CorrAddress!: QuestionEntity | undefined;

  qs_master_brokerLastName!: QuestionEntity | undefined;
  qs_master_brokerOrganizationName!: QuestionEntity | undefined;
  qs_master_borrowerCIN!: QuestionEntity | undefined;

  qs_master_buPcCode!: QuestionEntity | undefined;
  qs_master_uploadBuPcCode!: QuestionEntity | undefined;
  qs_master_rmName!: QuestionEntity | undefined;
  qs_master_rmContactNo!: QuestionEntity | undefined;
  qs_master_rmRemarks!: QuestionEntity | undefined;
  qs_master_insuredAddress!: QuestionEntity | undefined;

  qs_master_busReg2ndInsured!: QuestionEntity | undefined;
  qs_master_otherInsuredName!: QuestionEntity | undefined;
  qs_master_additionalInsured!: QuestionEntity | undefined;
  qs_master_insuredNo2!: QuestionEntity | undefined;
  qs_master_namesOtherInsured!: QuestionEntity | undefined;

  qs_master_insuredAddress_building!: QuestionEntity | undefined;
  qs_master_insuredAddress_lotunit!: QuestionEntity | undefined;
  qs_master_insuredAddress1!: QuestionEntity | undefined;
  qs_master_insuredAddress2!: QuestionEntity | undefined;
  //Address3/4 needed when Endorse Client-Info, ~\dbs-ep2-api\Baseline\Chubb.Library.Proposal\Base\ProposalExtend.cs
  qs_master_insuredAddress3!: QuestionEntity | undefined;
  qs_master_insuredAddress4!: QuestionEntity | undefined;
  qs_master_insuredPostalCode!: QuestionEntity | undefined;

  qs_master_insuredCity!: QuestionEntity | undefined;
  qs_master_insuredState!: QuestionEntity | undefined;
  qs_master_insuredCountry!: QuestionEntity | undefined;

  qs_master_insuredNo!: QuestionEntity | undefined;
  qs_master_insuredName!: QuestionEntity | undefined;
  qs_master_replacePolicyNo!: QuestionEntity | undefined;
  qs_master_masterPolicyNumber!: QuestionEntity | undefined;
  qs_master_planType!: QuestionEntity | undefined;
  qs_master_insuredNoNationality!: QuestionEntity | undefined;
  qs_master_insuredNo2Nationality!: QuestionEntity | undefined;
  qs_master_insuredNo2DocType!: QuestionEntity | undefined;

  qs_master_poi_startDate!: QuestionEntity | undefined;
  qs_master_poi_endDate!: QuestionEntity | undefined;

  /// 12/10/2018 : Chirag Added Code For FreeInsurance Start/End Date
  qs_master_FreeIns_startDate!: QuestionEntity | undefined;
  qs_master_FreeIns_endDate!: QuestionEntity | undefined;

  qs_master_mobileNumber!: QuestionEntity | undefined;
  qs_master_emailID!: QuestionEntity | undefined;

  ////DBSEP-252 : Client Info Update
  qs_master_salutation!: QuestionEntity | undefined;
  qs_master_clientName!: QuestionEntity | undefined;
  qs_master_passport!: QuestionEntity | undefined;
  qs_master_nric!: QuestionEntity | undefined;
  qs_master_occupation!: QuestionEntity | undefined;
  qs_master_birthDate!: QuestionEntity | undefined;
  qs_master_race!: QuestionEntity | undefined;
  qs_master_nationality!: QuestionEntity | undefined;
  qs_master_gender!: QuestionEntity | undefined;
  qs_master_maritalStatus!: QuestionEntity | undefined;
  qs_master_phoneNoHome!: QuestionEntity | undefined;
  qs_master_phoneNoOffice!: QuestionEntity | undefined;
  qs_master_faxNumber!: QuestionEntity | undefined;
  qs_master_cin!: QuestionEntity | undefined;
  qs_master_insuredNoDocType!: QuestionEntity | undefined;
  qs_master_clausesflag!: QuestionEntity | undefined;

  qs_master_financialBranch!: QuestionEntity | undefined;
  qs_master_bankReferNumber!: QuestionEntity | undefined;
  qs_master_assetClassCode!: QuestionEntity | undefined;
  qs_master_assetSerialNumber!: QuestionEntity | undefined;
  qs_master_effectiveDate!: QuestionEntity | undefined;
  qs_master_endorse_endorsementReason!: QuestionEntity | undefined;
  qs_master_cancellation_adjustmentAmount!: QuestionEntity | undefined;
  qs_master_cancellation_maximumAdjustmentAmount!: QuestionEntity | undefined;
  qs_master_refund!: QuestionEntity | undefined;
  qs_master_waiveMinimumPremium!: QuestionEntity | undefined;
  qs_master_cancellation_masterpiece!: QuestionEntity | undefined;
  qs_master_insuredIndustry!: QuestionEntity | undefined;
  qs_master_occupancyRate!: QuestionEntity | undefined;
  qs_master_miRate!: QuestionEntity | undefined;
  qs_master_insuredIndustry_desc!: QuestionEntity | undefined;
  qs_master_manualUnderwritting!: QuestionEntity | undefined;
  qs_location_occupation!: QuestionEntity | undefined;
  qs_location_riskAddress1!: QuestionEntity | undefined;
  qs_location_riskAddress2!: QuestionEntity | undefined;
  //questions: QuestionEntity[] = [];//no need anymore, since inherited from base

  qs_risk_floating!: QuestionEntity | undefined;
  qs_risk_sameAsAddress!: QuestionEntity | undefined;
  qs_risk_insuredAddress_building!: QuestionEntity | undefined;
  qs_risk_insuredAddress_lotunit!: QuestionEntity | undefined;
  qs_risk_insuredAddress1!: QuestionEntity | undefined;
  qs_risk_insuredAddress2!: QuestionEntity | undefined;
  qs_risk_insuredAddress3!: QuestionEntity | undefined;
  qs_risk_insuredDistCode!: QuestionEntity | undefined;
  qs_risk_insuredPostalCode!: QuestionEntity | undefined;
  qs_risk_insuredCity!: QuestionEntity | undefined;
  qs_risk_insuredState!: QuestionEntity | undefined;
  qs_risk_insuredCountry!: QuestionEntity | undefined;
  qs_risk_uploadRiskAddress!: QuestionEntity | undefined;
  qs_master_internalReference!: QuestionEntity | undefined;
  qs_master_notRenew!: QuestionEntity | undefined;
  // "Other Information" Section
  qs_otherinfo_MortgLoanAcctNum1!: QuestionEntity | undefined;
  qs_otherinfo_MortgLoanAcctNum2!: QuestionEntity | undefined;
  qs_otherinfo_MortgLoanAcctNum3!: QuestionEntity | undefined;
  qs_otherinfo_InsuranceCompany!: QuestionEntity | undefined;
  qs_otherinfo_VersionDate!: QuestionEntity | undefined;
  qs_otherinfo_MortgLoanRecEntryDate!: QuestionEntity | undefined;
  qs_otherinfo_RepayAcctType!: QuestionEntity | undefined;
  qs_otherinfo_RepayAcct!: QuestionEntity | undefined;
  qs_otherinfo_RepayAcctName!: QuestionEntity | undefined;
  qs_otherinfo_AutoIssue!: QuestionEntity | undefined;
  qs_otherinfo_PreGeneratePolicyNo!: QuestionEntity | undefined;
  qs_otherinfo_InsuranceOption!: QuestionEntity | undefined;
  qs_otherinfo_CurrentLoanValue!: QuestionEntity | undefined;
  qs_otherinfo_ProptyReinstaCost!: QuestionEntity | undefined;
  qs_otherinfo_ProptyReinstaCostDate!: QuestionEntity | undefined;
  qs_otherinfo_CustomerSegment!: QuestionEntity | undefined;

  // qs_fire_situation! : QuestionEntity | undefined;
  qs_fire_occupied!: QuestionEntity | undefined;
  qs_fire_notes!: QuestionEntity | undefined;
  qs_fire_excess!: QuestionEntity | undefined;
  qs_fire_mcst!: QuestionEntity | undefined;
  qs_fire_replacement!: QuestionEntity | undefined;
  qs_fire_generalPage!: QuestionEntity | undefined;
  qs_fire_businessDesc!: QuestionEntity | undefined;
  qs_fire_interestedParties!: QuestionEntity | undefined;
  qs_fire_discussionNotes!: QuestionEntity | undefined;

  qs_fire_natureBusiness!: QuestionEntity | undefined;
  qs_fire_usagePremises!: QuestionEntity | undefined;
  qs_fire_typeProperty!: QuestionEntity | undefined;
  qs_fire_freeInsuranceFirstYear!: QuestionEntity | undefined;
  qs_fire_nameSolicitors!: QuestionEntity | undefined;
  qs_fire_equipment_description!: QuestionEntity | undefined;
  qs_fire_equipment_type!: QuestionEntity | undefined;
  qs_fire_equipment_financing!: QuestionEntity | undefined;
  qs_fire_sumOfInsured!: QuestionEntity | undefined;
  qs_master_busReg1stInsured!: QuestionEntity | undefined;
  qs_fire_building!: QuestionEntity | undefined;
  qs_fire_householdContents!: QuestionEntity | undefined;
  qs_machinery_equipment!: QuestionEntity | undefined;
  qs_master_lst!: QuestionEntity | undefined;
  qs_master_lstDetails!: QuestionEntity | undefined;

  // IBG
  qs_master_dateOfBirthOrIncorporation!: QuestionEntity | undefined;
  qs_master_clientContactPerson!: QuestionEntity | undefined;
  qs_master_clientContactPersonContactNo!: QuestionEntity | undefined;
  qs_machinery_uploadSumInsured!: QuestionEntity | undefined;
  qs_machinery_uploadTypeOfEquipment!: QuestionEntity | undefined;
  qs_machinery_uploadEquipmentDescription!: QuestionEntity | undefined;
  qs_machinery_uploadTypeOfFinancing!: QuestionEntity | undefined;
  qs_fire_freeInsuranceNoYear!: QuestionEntity | undefined;
  qs_master_uploadAdditionalInsured!: QuestionEntity | undefined;

  //Citibank
  qs_master_premiumPayment!: QuestionEntity | undefined;
  qs_master_customerType!: QuestionEntity | undefined;
  qs_master_collateralNumber: QuestionEntity | undefined;
  qs_master_discountCode!: QuestionEntity | undefined;
  qs_master_discountType!: QuestionEntity | undefined;
  qs_fire_outstandingLoanValue!: QuestionEntity | undefined;
  qs_fire_coverageValueType!: QuestionEntity | undefined;
  qs_master_customDiscountCode!: QuestionEntity | undefined;
  qs_risk_occupancy!: QuestionEntity | undefined;
  qs_risk_construction!: QuestionEntity | undefined;

  //#region HASE
  qs_master_rmBranchCode!: QuestionEntity | undefined;
  qs_master_rmMortgageeCode!: QuestionEntity | undefined;
  qs_master_rmSalesChannel!: QuestionEntity | undefined;
  qs_master_rmStaffReference!: QuestionEntity | undefined;
  qs_master_rmSalesStaffCode!: QuestionEntity | undefined;
  //#endregion

  qs_risk_carParkAddress1!: QuestionEntity | undefined;
  qs_risk_carParkAddress2!: QuestionEntity | undefined;
  qs_risk_carParkAddress3!: QuestionEntity | undefined;
  qs_risk_carParkAddress4!: QuestionEntity | undefined;
  qs_risk_carParkCountry!: QuestionEntity | undefined;

  qs_fire_grossFloorArea!: QuestionEntity | undefined;
  qs_fire_loanAmount!: QuestionEntity | undefined;
  qs_fire_currency!: QuestionEntity | undefined;
  qs_fire_freeInsurance!: QuestionEntity | undefined;

  nationalityList!: any[];

  constructor(public override masterDataService: MasterDataService) {
    super(MortgageFireHKTabSchema.master.index, masterDataService);
  }

  initializeQuestionSchema() {
    this.qs_master_brokerFirstName = new QuestionEntity(
      "qs_master_brokerFirstName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_brokerFirstName.displayText = "First Name";
    this.qs_master_brokerFirstName.maxLength = 100;
    this.qs_master_brokerFirstName.required = false;
    this.qs_master_brokerFirstName.tabId = this.tabId;
    this.qs_master_brokerFirstName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_brokerLastName = new QuestionEntity(
      "qs_master_brokerLastName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_brokerLastName.displayText = "Last Name";
    this.qs_master_brokerLastName.maxLength = 100;
    this.qs_master_brokerLastName.required = true;
    this.qs_master_brokerLastName.tabId = this.tabId;
    this.qs_master_brokerLastName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_brokerOrganizationName = new QuestionEntity(
      "qs_master_brokerOrganizationName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_brokerOrganizationName.displayText = "Insured Name";
    this.qs_master_brokerOrganizationName.maxLength = 100;
    this.qs_master_brokerOrganizationName.required = true;
    this.qs_master_brokerOrganizationName.tabId = this.tabId;
    this.qs_master_brokerOrganizationName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    // New IBG broker requirement
    this.qs_master_insuredAddress = new QuestionEntity(
      "qs_master_insuredAddress",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress.displayText =
      "Uploaded correspondence address";
    this.qs_master_insuredAddress.readOnly = true;
    this.qs_master_insuredAddress.required = false;
    this.qs_master_insuredAddress.tabId = this.tabId;
    this.qs_master_insuredAddress.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredAddress_building = new QuestionEntity(
      "qs_master_insuredAddress_building",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress_building.displayText = "Building Name";
    this.qs_master_insuredAddress_building.required = false;
    this.qs_master_insuredAddress_building.tabId = this.tabId;
    this.qs_master_insuredAddress_building.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredAddress_lotunit = new QuestionEntity(
      "qs_master_insuredAddress_lotunit",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress_lotunit.displayText = "Suite/Lot/Unit Number";
    this.qs_master_insuredAddress_lotunit.required = false;
    this.qs_master_insuredAddress_lotunit.tabId = this.tabId;
    this.qs_master_insuredAddress_lotunit.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredAddress1 = new QuestionEntity(
      "qs_master_insuredAddress1",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress1.displayText = "Address No 1";
    this.qs_master_insuredAddress1.readOnly = true;
    this.qs_master_insuredAddress1.required = false;
    this.qs_master_insuredAddress1.tabId = this.tabId;
    this.qs_master_insuredAddress1.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredAddress2 = new QuestionEntity(
      "qs_master_insuredAddress2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress2.displayText = "Address No 2";
    this.qs_master_insuredAddress2.readOnly = true;
    this.qs_master_insuredAddress2.required = false;
    this.qs_master_insuredAddress2.tabId = this.tabId;
    this.qs_master_insuredAddress2.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredAddress3 = new QuestionEntity(
      "qs_master_insuredAddress3",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress3.displayText = "Address No 3";
    this.qs_master_insuredAddress3.readOnly = true;
    this.qs_master_insuredAddress3.required = false;
    this.qs_master_insuredAddress3.tabId = this.tabId;
    this.qs_master_insuredAddress3.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredAddress4 = new QuestionEntity(
      "qs_master_insuredAddress4",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredAddress4.displayText = "Address No 4";
    this.qs_master_insuredAddress4.readOnly = true;
    this.qs_master_insuredAddress4.required = false;
    this.qs_master_insuredAddress4.tabId = this.tabId;
    this.qs_master_insuredAddress4.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredPostalCode = new QuestionEntity(
      "qs_master_insuredPostalCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredPostalCode.displayText = "PostCode";
    this.qs_master_insuredPostalCode.readOnly = true;
    this.qs_master_insuredPostalCode.required = false;
    this.qs_master_insuredPostalCode.tabId = this.tabId;
    this.qs_master_insuredPostalCode.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredCity = new QuestionEntity(
      "qs_master_insuredCity",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredCity.displayText = "City/Suburb";
    this.qs_master_insuredCity.readOnly = true;
    this.qs_master_insuredCity.required = false;
    this.qs_master_insuredCity.tabId = this.tabId;
    this.qs_master_insuredCity.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredState = new QuestionEntity(
      "qs_master_insuredState",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredState.displayText = "State";
    this.qs_master_insuredState.readOnly = true;
    this.qs_master_insuredState.required = false;
    this.qs_master_insuredState.tabId = this.tabId;
    this.qs_master_insuredState.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredCountry = new QuestionEntity(
      "qs_master_insuredCountry",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredCountry.displayText = "Country";
    this.qs_master_insuredCountry.readOnly = true;
    this.qs_master_insuredCountry.answer = "Hong Kong";
    this.qs_master_insuredCountry.required = true;

    this.qs_master_insuredCountry.tabId = this.tabId;
    this.qs_master_insuredCountry.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_carParkAddress1 = new QuestionEntity(
      "qs_risk_carParkAddress1",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_carParkAddress1.displayText = "Address Line 1";
    this.qs_risk_carParkAddress1.required = false;
    this.qs_risk_carParkAddress1.tabId = this.tabId;
    this.qs_risk_carParkAddress1.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_carParkAddress2 = new QuestionEntity(
      "qs_risk_carParkAddress2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_carParkAddress2.displayText = "Address Line 2";
    this.qs_risk_carParkAddress2.required = false;
    this.qs_risk_carParkAddress2.tabId = this.tabId;
    this.qs_risk_carParkAddress2.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_carParkAddress3 = new QuestionEntity(
      "qs_risk_carParkAddress3",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_carParkAddress3.displayText = "Address Line 3";
    this.qs_risk_carParkAddress3.required = false;
    this.qs_risk_carParkAddress3.tabId = this.tabId;
    this.qs_risk_carParkAddress3.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;
    this.qs_risk_carParkAddress4 = new QuestionEntity(
      "qs_risk_carParkAddress4",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_carParkAddress4.displayText = "Address Line 4";
    this.qs_risk_carParkAddress4.required = false;
    this.qs_risk_carParkAddress4.tabId = this.tabId;
    this.qs_risk_carParkAddress4.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;
    this.qs_risk_carParkCountry = new QuestionEntity(
      "qs_risk_carParkCountry",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_carParkCountry.displayText = "Country";
    this.qs_risk_carParkCountry.required = true;
    this.qs_risk_carParkCountry.readOnly = true;
    this.qs_risk_carParkCountry.answer = "HK"; //default to HK, use ISO code
    this.qs_risk_carParkCountry.tabId = this.tabId;
    this.qs_risk_carParkCountry.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_grossFloorArea = new QuestionEntity(
      "qs_fire_grossFloorArea",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_grossFloorArea.displayText = "Gross Floor Area";
    this.qs_fire_grossFloorArea.required = false;
    this.qs_fire_grossFloorArea.tabId = this.tabId;
    this.qs_fire_grossFloorArea.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_loanAmount = new QuestionEntity(
      "qs_fire_loanAmount",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_loanAmount.displayText = "Loan Amount";
    this.qs_fire_loanAmount.required = false;
    this.qs_fire_loanAmount.tabId = this.tabId;
    this.qs_fire_loanAmount.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_currency = new QuestionEntity(
      "qs_fire_currency",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_currency.displayText = "Currency";
    this.qs_fire_currency.required = false;
    this.qs_fire_currency.tabId = this.tabId;
    this.qs_fire_currency.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_freeInsurance = new QuestionEntity(
      "qs_fire_freeInsurance",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_freeInsurance.displayText = "Free Insurance";
    this.qs_fire_freeInsurance.required = false;
    this.qs_fire_freeInsurance.tabId = this.tabId;
    this.qs_fire_freeInsurance.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_buPcCode = new QuestionEntity(
      "qs_master_buPcCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_buPcCode.displayText = "BU PC Code";
    this.qs_master_buPcCode.required = true;
    this.qs_master_buPcCode.tabId = this.tabId;
    this.qs_master_buPcCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_uploadBuPcCode = new QuestionEntity(
      "qs_master_uploadBuPcCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_uploadBuPcCode.displayText = "Uploaded BU PC Code";
    this.qs_master_uploadBuPcCode.required = false;
    this.qs_master_uploadBuPcCode.readOnly = true;
    this.qs_master_uploadBuPcCode.tabId = this.tabId;
    this.qs_master_uploadBuPcCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmName = new QuestionEntity(
      "qs_master_rmName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmName.displayText = "Name";
    this.qs_master_rmName.maxLength = 100;
    this.qs_master_rmName.required = false;
    this.qs_master_rmName.tabId = this.tabId;
    this.qs_master_rmName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmContactNo = new QuestionEntity(
      "qs_master_rmContactNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmContactNo.displayText = "Contact No";
    this.qs_master_rmContactNo.required = false;
    this.qs_master_rmContactNo.tabId = this.tabId;
    this.qs_master_rmContactNo.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmRemarks = new QuestionEntity(
      "qs_master_rmRemarks",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmRemarks.displayText = "Remarks";
    this.qs_master_rmRemarks.required = false;
    this.qs_master_rmRemarks.tabId = this.tabId;
    this.qs_master_rmRemarks.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    // End new IBG

    // New IBG Client Information
    this.qs_master_busReg1stInsured = new QuestionEntity(
      "qs_master_busReg1stInsured",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_busReg1stInsured.displayText =
      "Business Registration No / NRIC No (1st Insured)";
    this.qs_master_busReg1stInsured.required = false;
    this.qs_master_busReg1stInsured.tabId = this.tabId;
    this.qs_master_busReg1stInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_busReg2ndInsured = new QuestionEntity(
      "qs_master_busReg2ndInsured",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_busReg2ndInsured.displayText =
      "Business Registration No / NRIC No (2nd Insured)";
    this.qs_master_busReg2ndInsured.required = false;
    this.qs_master_busReg2ndInsured.tabId = this.tabId;
    this.qs_master_busReg2ndInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_otherInsuredName = new QuestionEntity(
      "qs_master_otherInsuredName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_otherInsuredName.displayText = "Other Insured Name";
    this.qs_master_otherInsuredName.required = false;
    this.qs_master_otherInsuredName.tabId = this.tabId;
    this.qs_master_otherInsuredName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_additionalInsured = new QuestionEntity(
      "qs_master_additionalInsured",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_additionalInsured.displayText =
      "Names other than Insured(if any)";
    this.qs_master_additionalInsured.required = false;
    this.qs_master_additionalInsured.tabId = this.tabId;
    this.qs_master_additionalInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    // End IBG Client Information

    this.qs_master_insuredNo = new QuestionEntity(
      "qs_master_insuredNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNo.displayText = "Client No";
    this.qs_master_insuredNo.required = true;
    this.qs_master_insuredNo.readOnly = true;
    this.qs_master_insuredNo.tabId = this.tabId;
    this.qs_master_insuredNo.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredNoNationality = new QuestionEntity(
      "qs_master_insuredNoNationality",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNoNationality.displayText = "Nationality";
    this.qs_master_insuredNoNationality.required = false;
    this.qs_master_insuredNoNationality.readOnly = false;
    this.qs_master_insuredNoNationality.tabId = this.tabId;
    this.qs_master_insuredNoNationality.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredNoDocType = new QuestionEntity(
      "qs_master_insuredNoDocType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNoDocType.displayText = "Document Type";
    this.qs_master_insuredNoDocType.required = false;
    this.qs_master_insuredNoDocType.readOnly = false;
    this.qs_master_insuredNoDocType.tabId = this.tabId;
    this.qs_master_insuredNoDocType.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_clausesflag = new QuestionEntity(
      "qs_master_clausesflag",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_clausesflag.displayText = "Clauses Flag";
    this.qs_master_clausesflag.required = false;
    this.qs_master_clausesflag.readOnly = false;
    this.qs_master_clausesflag.tabId = this.tabId;
    this.qs_master_clausesflag.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredName = new QuestionEntity(
      "qs_master_insuredName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredName.displayText = "Client Name";
    this.qs_master_insuredName.readOnly = true;
    this.qs_master_insuredName.required = true;
    this.qs_master_insuredName.tabId = this.tabId;
    this.qs_master_insuredName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_replacePolicyNo = new QuestionEntity(
      "qs_master_replacePolicyNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_replacePolicyNo.displayText = "Replacing Policy No";
    this.qs_master_replacePolicyNo.required = false;
    this.qs_master_replacePolicyNo.tabId = this.tabId;
    this.qs_master_replacePolicyNo.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_masterPolicyNumber = new QuestionEntity(
      "qs_master_masterPolicyNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_masterPolicyNumber.displayText = "Master Policy Number";
    this.qs_master_masterPolicyNumber.required = false;
    this.qs_master_masterPolicyNumber.tabId = this.tabId;
    this.qs_master_masterPolicyNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_planType = new QuestionEntity(
      "qs_master_planType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_planType.displayText = "No Of Years";
    this.qs_master_planType.required = false;
    this.qs_master_planType.tabId = this.tabId;
    this.qs_master_planType.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_financialBranch = new QuestionEntity(
      "qs_master_financialBranch",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_financialBranch.displayText = "Financial Institution Branch";
    this.qs_master_financialBranch.required = true;
    this.qs_master_financialBranch.tabId = this.tabId;
    this.qs_master_financialBranch.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_bankReferNumber = new QuestionEntity(
      "qs_master_bankReferNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_bankReferNumber.displayText = "Bank/Cross Reference Number";
    this.qs_master_bankReferNumber.required = true;
    this.qs_master_bankReferNumber.tabId = this.tabId;
    this.qs_master_bankReferNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_assetClassCode = new QuestionEntity(
      "qs_master_assetClassCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_assetClassCode.displayText = "Asset Class Code";
    this.qs_master_assetClassCode.required = false;
    this.qs_master_assetClassCode.tabId = this.tabId;
    this.qs_master_assetClassCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_assetSerialNumber = new QuestionEntity(
      "qs_master_assetSerialNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_assetSerialNumber.displayText = "Asset Serial Number";
    this.qs_master_assetSerialNumber.required = false;
    this.qs_master_assetSerialNumber.tabId = this.tabId;
    this.qs_master_assetSerialNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_poi_startDate = new QuestionEntity(
      "qs_master_poi_startDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_poi_startDate.displayText = "Policy Inception Date";
    this.qs_master_poi_startDate.answer = new Date();
    // Set the minimum date to be selected to 30 days before the current Date
    // this.qs_master_poi_startDate.minValue =
    // new Date(new Date(this.qs_master_poi_startDate.answer).setDate(new Date(this.qs_master_poi_startDate.answer).getDate() - 30));
    this.qs_master_poi_startDate.required = true;
    this.qs_master_poi_startDate.tabId = this.tabId;
    this.qs_master_poi_startDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_effectiveDate = new QuestionEntity(
      "qs_master_effectiveDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_effectiveDate.displayText = "Effective Date";
    this.qs_master_effectiveDate.answer = new Date();
    this.qs_master_effectiveDate.tabId = this.tabId;
    this.qs_master_effectiveDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_poi_endDate = new QuestionEntity(
      "qs_master_poi_endDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_poi_endDate.displayText = "Policy Expiry Date";
    this.qs_master_poi_endDate.answer = new Date();
    this.qs_master_poi_endDate.tabId = this.tabId;
    this.qs_master_poi_endDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    /// 12/10/2018 : Chirag Added Code For FreeInsurance Start/End Date
    this.qs_master_FreeIns_startDate = new QuestionEntity(
      "qs_master_FreeIns_startDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_FreeIns_startDate.displayText = "Free Insurance Start Date";
    this.qs_master_FreeIns_startDate.answer = new Date();
    this.qs_master_FreeIns_startDate.readOnly = true;
    this.qs_master_FreeIns_startDate.required = false;
    this.qs_master_FreeIns_startDate.tabId = this.tabId;
    this.qs_master_FreeIns_startDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_FreeIns_endDate = new QuestionEntity(
      "qs_master_FreeIns_endDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_FreeIns_endDate.displayText = "Free Insurance End Date";
    this.qs_master_FreeIns_endDate.answer = new Date();
    this.qs_master_FreeIns_endDate.required = false;
    this.qs_master_FreeIns_endDate.readOnly = true;
    this.qs_master_FreeIns_endDate.tabId = this.tabId;
    this.qs_master_FreeIns_endDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    //Implemetaion Preferred Delivery method
    this.qs_master_preferredDeliveryMethod = new QuestionEntity(
      "qs_master_preferredDeliveryMethod",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_preferredDeliveryMethod.displayText =
      "Preferred Delivery Method";
    this.qs_master_preferredDeliveryMethod.required = true;
    this.qs_master_preferredDeliveryMethod.tabId = this.tabId;
    this.qs_master_preferredDeliveryMethod.readOnly = false;
    this.qs_master_preferredDeliveryMethod.answer = 5;
    this.qs_master_preferredDeliveryMethod.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_preferredDeliveryMethod_Email = new QuestionEntity(
      "qs_master_preferredDeliveryMethod_Email",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_preferredDeliveryMethod_Email.displayText = "Email";
    this.qs_master_preferredDeliveryMethod_Email.required = false;
    this.qs_master_preferredDeliveryMethod_Email.tabId = this.tabId;
    this.qs_master_preferredDeliveryMethod_Email.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_preferredDeliveryMethod_MobileNo = new QuestionEntity(
      "qs_master_preferredDeliveryMethod_MobileNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_preferredDeliveryMethod_MobileNo.displayText =
      "Mobile Number";
    this.qs_master_preferredDeliveryMethod_MobileNo.required = false;
    this.qs_master_preferredDeliveryMethod_MobileNo.tabId = this.tabId;
    this.qs_master_preferredDeliveryMethod_MobileNo.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_preferredDeliveryMethod_CorrAddress = new QuestionEntity(
      "qs_master_preferredDeliveryMethod_CorrAddress",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_preferredDeliveryMethod_CorrAddress.displayText =
      "Corresponding Address";
    this.qs_master_preferredDeliveryMethod_CorrAddress.required = false;
    this.qs_master_preferredDeliveryMethod_CorrAddress.tabId = this.tabId;
    this.qs_master_preferredDeliveryMethod_CorrAddress.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    // End Of delivery Method Block

    /// 12/10/2018 : Chirag Added Code For Mobile/Email Address
    this.qs_master_mobileNumber = new QuestionEntity(
      "qs_master_mobileNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_mobileNumber.displayText = "Mobile Number";
    this.qs_master_mobileNumber.required = false;
    this.qs_master_mobileNumber.tabId = this.tabId;
    this.qs_master_mobileNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_emailID = new QuestionEntity(
      "qs_master_emailID",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_emailID.displayText = "Email";
    this.qs_master_emailID.required = false;
    this.qs_master_emailID.tabId = this.tabId;
    this.qs_master_emailID.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    ////DBSEP-252 : Client Info Update
    this.qs_master_salutation = new QuestionEntity(
      "qs_master_salutation",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_salutation.displayText = "Salutation";
    this.qs_master_salutation.required = false;
    this.qs_master_salutation.tabId = this.tabId;
    this.qs_master_salutation.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_clientName = new QuestionEntity(
      "qs_master_clientName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_clientName.displayText = "ClientName";
    this.qs_master_clientName.required = false;
    this.qs_master_clientName.tabId = this.tabId;
    this.qs_master_clientName.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_passport = new QuestionEntity(
      "qs_master_passport",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_passport.displayText = "Passport";
    this.qs_master_passport.required = false;
    this.qs_master_passport.tabId = this.tabId;
    this.qs_master_passport.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_nric = new QuestionEntity(
      "qs_master_nric",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_nric.displayText = "NRIC";
    this.qs_master_nric.required = false;
    this.qs_master_nric.tabId = this.tabId;
    this.qs_master_nric.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_occupation = new QuestionEntity(
      "qs_master_occupation",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_occupation.displayText = "Occupation";
    this.qs_master_occupation.required = false;
    this.qs_master_occupation.tabId = this.tabId;
    this.qs_master_occupation.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_birthDate = new QuestionEntity(
      "qs_master_birthDate",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_birthDate.displayText = "Birth Date";
    this.qs_master_birthDate.required = false;
    this.qs_master_birthDate.tabId = this.tabId;
    this.qs_master_birthDate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_race = new QuestionEntity(
      "qs_master_race",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_race.displayText = "Race";
    this.qs_master_race.required = false;
    this.qs_master_race.tabId = this.tabId;
    this.qs_master_race.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_nationality = new QuestionEntity(
      "qs_master_nationality",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_nationality.displayText = "Nationality";
    this.qs_master_nationality.required = false;
    this.qs_master_nationality.tabId = this.tabId;
    this.qs_master_nationality.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_gender = new QuestionEntity(
      "qs_master_gender",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_gender.displayText = "Gender";
    this.qs_master_gender.required = false;
    this.qs_master_gender.tabId = this.tabId;
    this.qs_master_gender.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_maritalStatus = new QuestionEntity(
      "qs_master_maritalStatus",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_maritalStatus.displayText = "Marital Status";
    this.qs_master_maritalStatus.required = false;
    this.qs_master_maritalStatus.tabId = this.tabId;
    this.qs_master_maritalStatus.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_phoneNoHome = new QuestionEntity(
      "qs_master_phoneNoHome",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_phoneNoHome.displayText = "PhoneNo Home";
    this.qs_master_phoneNoHome.required = false;
    this.qs_master_phoneNoHome.tabId = this.tabId;
    this.qs_master_phoneNoHome.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_phoneNoOffice = new QuestionEntity(
      "qs_master_phoneNoOffice",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_phoneNoOffice.displayText = "Office No";
    this.qs_master_phoneNoOffice.required = false;
    this.qs_master_phoneNoOffice.tabId = this.tabId;
    this.qs_master_phoneNoOffice.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_faxNumber = new QuestionEntity(
      "qs_master_faxNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_faxNumber.displayText = "Fax Number";
    this.qs_master_faxNumber.required = false;
    this.qs_master_faxNumber.tabId = this.tabId;
    this.qs_master_faxNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_cin = new QuestionEntity(
      "qs_master_cin",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_cin.displayText = "CIN";
    this.qs_master_cin.required = false;
    this.qs_master_cin.tabId = this.tabId;
    this.qs_master_cin.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_endorse_endorsementReason = new QuestionEntity(
      "qs_master_endorse_endorsementReason",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_endorse_endorsementReason.displayText = "Remarks";
    this.qs_master_endorse_endorsementReason.required = false;
    this.qs_master_endorse_endorsementReason.tabId = this.tabId;
    this.qs_master_endorse_endorsementReason.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_refund = new QuestionEntity(
      "qs_master_refund",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_refund.displayText = "Remarks";
    this.qs_master_refund.required = false;
    this.qs_master_refund.tabId = this.tabId;
    this.qs_master_refund.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_waiveMinimumPremium = new QuestionEntity(
      "qs_master_waiveMinimumPremium",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_waiveMinimumPremium.displayText = "WaiveMinimumPremium";
    this.qs_master_waiveMinimumPremium.defaultAnswer = "False";
    this.qs_master_waiveMinimumPremium.answer = "False";
    this.qs_master_waiveMinimumPremium.required = false;
    this.qs_master_waiveMinimumPremium.isVisible = false;
    this.qs_master_waiveMinimumPremium.tabId = this.tabId;
    this.qs_master_waiveMinimumPremium.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_cancellation_masterpiece = new QuestionEntity(
      "qs_master_cancellation_masterpiece",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_cancellation_masterpiece.displayText =
      "Masterpiece Issuance";
    this.qs_master_cancellation_masterpiece.defaultAnswer = "False";
    this.qs_master_cancellation_masterpiece.answer = "False";
    this.qs_master_cancellation_masterpiece.required = false;
    this.qs_master_cancellation_masterpiece.isVisible = false;
    this.qs_master_cancellation_masterpiece.tabId = this.tabId;
    this.qs_master_cancellation_masterpiece.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_cancellation_adjustmentAmount = new QuestionEntity(
      "qs_master_cancellation_adjustmentAmount",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_master_cancellation_adjustmentAmount.displayText =
      "Adjustment Amount";
    this.qs_master_cancellation_adjustmentAmount.isVisible = false;
    this.qs_master_cancellation_adjustmentAmount.required = false;
    this.qs_master_cancellation_adjustmentAmount.readOnly = true;
    this.qs_master_cancellation_adjustmentAmount.tabId = this.tabId;
    this.qs_master_cancellation_adjustmentAmount.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    this.qs_master_cancellation_adjustmentAmount.answer = 0;
    this.qs_master_cancellation_adjustmentAmount.decimals = 2;

    this.qs_master_cancellation_maximumAdjustmentAmount = new QuestionEntity(
      "qs_master_cancellation_maximumAdjustmentAmount",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_master_cancellation_maximumAdjustmentAmount.displayText =
      "Maximum Adjustment Amount";
    this.qs_master_cancellation_maximumAdjustmentAmount.isVisible = false;
    this.qs_master_cancellation_maximumAdjustmentAmount.readOnly = true;
    this.qs_master_cancellation_maximumAdjustmentAmount.required = false;
    this.qs_master_cancellation_maximumAdjustmentAmount.tabId = this.tabId;
    this.qs_master_cancellation_maximumAdjustmentAmount.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredIndustry = new QuestionEntity(
      "qs_master_insuredIndustry",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredIndustry.displayText = "NAICS";
    this.qs_master_insuredIndustry.required = true;
    this.qs_master_insuredIndustry.tabId = this.tabId;
    this.qs_master_insuredIndustry.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_occupancyRate = new QuestionEntity(
      "qs_master_occupancyRate",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_occupancyRate.displayText = "Occupancy Rates";
    this.qs_master_occupancyRate.required = true;
    this.qs_master_occupancyRate.tabId = this.tabId;
    this.qs_master_occupancyRate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_miRate = new QuestionEntity(
      "qs_master_miRate",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_miRate.displayText = "Mi Rates";
    this.qs_master_miRate.required = true;
    this.qs_master_miRate.tabId = this.tabId;
    this.qs_master_miRate.readOnly = true;
    this.qs_master_miRate.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    this.qs_master_miRate.options = [
      { key: "MI", value: "1" },
      { key: "Non-MI", value: "2" },
    ];

    this.qs_location_occupation = new QuestionEntity(
      "qs_location_occupation",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_location_occupation.displayText = "Location Occupation";
    this.qs_location_occupation.required = true;
    this.qs_location_occupation.tabId = this.tabId;
    this.qs_location_occupation.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_insuredIndustry_desc = new QuestionEntity(
      "qs_master_insuredIndustry_desc",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredIndustry_desc.displayText = "Occupation Description";
    this.qs_master_insuredIndustry_desc.required = false;
    this.qs_master_insuredIndustry_desc.tabId = this.tabId;
    this.qs_master_insuredIndustry_desc.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_location_riskAddress1 = new QuestionEntity(
      "qs_location_riskAddress1",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_location_riskAddress1.displayText = "Location Address 1";
    this.qs_location_riskAddress1.required = true;
    this.qs_location_riskAddress1.tabId = this.tabId;
    this.qs_location_riskAddress1.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_location_riskAddress2 = new QuestionEntity(
      "qs_location_riskAddress2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_location_riskAddress2.displayText = "Location Address 2";
    this.qs_location_riskAddress2.required = true;
    this.qs_location_riskAddress2.tabId = this.tabId;
    this.qs_location_riskAddress2.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_floating = new QuestionEntity(
      "qs_risk_floating",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_floating.displayText = "Floating";
    this.qs_risk_floating.options = [
      { key: "Yes", value: "1" },
      { key: "No", value: "2" },
    ];
    this.qs_risk_floating.required = false;
    this.qs_risk_floating.tabId = this.tabId;
    this.qs_risk_floating.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_sameAsAddress = new QuestionEntity(
      "qs_risk_sameAsAddress",
      undefined,
      Enums.AnswerDataType.Boolean
    );
    this.qs_risk_sameAsAddress.displayText =
      "Same as Client’s Contact Information";
    this.qs_risk_sameAsAddress.required = false;
    this.qs_risk_sameAsAddress.tabId = this.tabId;
    this.qs_risk_sameAsAddress.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredAddress_building = new QuestionEntity(
      "qs_risk_insuredAddress_building",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredAddress_building.displayText = "Building Name";
    this.qs_risk_insuredAddress_building.required = true;
    this.qs_risk_insuredAddress_building.tabId = this.tabId;
    this.qs_risk_insuredAddress_building.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredAddress_lotunit = new QuestionEntity(
      "qs_risk_insuredAddress_lotunit",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredAddress_lotunit.displayText = "Suite/Lot/Unit Number";
    this.qs_risk_insuredAddress_lotunit.required = true;
    this.qs_risk_insuredAddress_lotunit.tabId = this.tabId;
    this.qs_risk_insuredAddress_lotunit.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredAddress1 = new QuestionEntity(
      "qs_risk_insuredAddress1",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredAddress1.displayText = "Address No 1";
    this.qs_risk_insuredAddress1.required = true;
    this.qs_risk_insuredAddress1.tabId = this.tabId;
    this.qs_risk_insuredAddress1.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredAddress2 = new QuestionEntity(
      "qs_risk_insuredAddress2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredAddress2.displayText = "Address No 2";
    this.qs_risk_insuredAddress2.required = true;
    this.qs_risk_insuredAddress2.tabId = this.tabId;
    this.qs_risk_insuredAddress2.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredAddress3 = new QuestionEntity(
      "qs_risk_insuredAddress3",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredAddress3.displayText = "Address No 2";
    this.qs_risk_insuredAddress3.required = true;
    this.qs_risk_insuredAddress3.tabId = this.tabId;
    this.qs_risk_insuredAddress3.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredDistCode = new QuestionEntity(
      "qs_risk_insuredDistCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredDistCode.displayText = "District Code";
    this.qs_risk_insuredDistCode.required = false;
    this.qs_risk_insuredDistCode.tabId = this.tabId;
    this.qs_risk_insuredDistCode.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredPostalCode = new QuestionEntity(
      "qs_risk_insuredPostalCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredPostalCode.displayText = "PostCode";
    this.qs_risk_insuredPostalCode.required = false; //no needed for Hase
    this.qs_risk_insuredPostalCode.tabId = this.tabId;
    this.qs_risk_insuredPostalCode.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredCity = new QuestionEntity(
      "qs_risk_insuredCity",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredCity.displayText = "City/Suburb";
    this.qs_risk_insuredCity.required = false; //no needed for Hase
    this.qs_risk_insuredCity.tabId = this.tabId;
    this.qs_risk_insuredCity.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredState = new QuestionEntity(
      "qs_risk_insuredState",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredState.displayText = "State";
    this.qs_risk_insuredState.required = false;
    this.qs_risk_insuredState.tabId = this.tabId;
    this.qs_risk_insuredState.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_insuredCountry = new QuestionEntity(
      "qs_risk_insuredCountry",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_insuredCountry.displayText = "Country";
    this.qs_risk_insuredCountry.answer = "HK"; //default to HK, use ISO code
    this.qs_risk_insuredCountry.required = true;
    this.qs_risk_insuredCountry.readOnly = true;
    this.qs_risk_insuredCountry.tabId = this.tabId;
    this.qs_risk_insuredCountry.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_risk_uploadRiskAddress = new QuestionEntity(
      "qs_risk_uploadRiskAddress",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_uploadRiskAddress.displayText = "Uploaded risk address";
    this.qs_risk_uploadRiskAddress.readOnly = true;
    this.qs_risk_uploadRiskAddress.required = false;
    this.qs_risk_uploadRiskAddress.tabId = this.tabId;
    this.qs_risk_uploadRiskAddress.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_occupied = new QuestionEntity(
      "qs_fire_occupied",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_occupied.displayText = "Occupied as";
    this.qs_fire_occupied.required = true;
    this.qs_fire_occupied.tabId = this.tabId;
    this.qs_fire_occupied.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;
    this.qs_master_manualUnderwritting = new QuestionEntity(
      "qs_master_manualUnderwritting",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_manualUnderwritting.displayText = "Manual Underwriting";
    this.qs_master_manualUnderwritting.required = true;
    this.qs_master_manualUnderwritting.tabId = this.tabId;
    this.qs_master_manualUnderwritting.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_notes = new QuestionEntity(
      "qs_fire_notes",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_notes.displayText = "Additional Notes on occupancy";
    this.qs_fire_notes.required = false;
    this.qs_fire_notes.tabId = this.tabId;
    this.qs_fire_notes.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_mcst = new QuestionEntity(
      "qs_fire_mcst",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_mcst.displayText = "MCST Number";
    this.qs_fire_mcst.required = false;
    this.qs_fire_mcst.isVisible = false;
    this.qs_fire_mcst.tabId = this.tabId;
    this.qs_fire_mcst.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_replacement = new QuestionEntity(
      "qs_fire_replacement",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_replacement.displayText =
      "Fire Replacement Value / Sum Insured";
    this.qs_fire_replacement.required = false;
    this.qs_fire_replacement.tabId = this.tabId;
    this.qs_fire_replacement.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    // "Other Information" Section
    this.qs_otherinfo_MortgLoanAcctNum1 = new QuestionEntity(
      "qs_otherinfo_MortgLoanAcctNum1",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_MortgLoanAcctNum1.displayText = "Loan Account Number1";
    this.qs_otherinfo_MortgLoanAcctNum1.required = false;
    this.qs_otherinfo_MortgLoanAcctNum1.tabId = this.tabId;
    this.qs_otherinfo_MortgLoanAcctNum1.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_MortgLoanAcctNum2 = new QuestionEntity(
      "qs_otherinfo_MortgLoanAcctNum2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_MortgLoanAcctNum2.displayText = "Loan Account Number2";
    this.qs_otherinfo_MortgLoanAcctNum2.required = false;
    this.qs_otherinfo_MortgLoanAcctNum2.tabId = this.tabId;
    this.qs_otherinfo_MortgLoanAcctNum2.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_MortgLoanAcctNum3 = new QuestionEntity(
      "qs_otherinfo_MortgLoanAcctNum3",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_MortgLoanAcctNum3.displayText = "Loan Account Number3";
    this.qs_otherinfo_MortgLoanAcctNum3.required = false;
    this.qs_otherinfo_MortgLoanAcctNum3.tabId = this.tabId;
    this.qs_otherinfo_MortgLoanAcctNum3.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_InsuranceCompany = new QuestionEntity(
      "qs_otherinfo_InsuranceCompany",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_InsuranceCompany.displayText = "Insurance Company";
    this.qs_otherinfo_InsuranceCompany.required = false;
    this.qs_otherinfo_InsuranceCompany.tabId = this.tabId;
    this.qs_otherinfo_InsuranceCompany.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_VersionDate = new QuestionEntity(
      "qs_otherinfo_VersionDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_otherinfo_VersionDate.displayText = "Version Date";
    this.qs_otherinfo_VersionDate.required = false;
    this.qs_otherinfo_VersionDate.tabId = this.tabId;
    this.qs_otherinfo_VersionDate.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_MortgLoanRecEntryDate = new QuestionEntity(
      "qs_otherinfo_MortgLoanRecEntryDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_otherinfo_MortgLoanRecEntryDate.displayText =
      "Mortgage Loan Record Entry Date";
    this.qs_otherinfo_MortgLoanRecEntryDate.required = false;
    this.qs_otherinfo_MortgLoanRecEntryDate.tabId = this.tabId;
    this.qs_otherinfo_MortgLoanRecEntryDate.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_RepayAcctType = new QuestionEntity(
      "qs_otherinfo_RepayAcctType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_RepayAcctType.displayText = "Repayment Account Type";
    this.qs_otherinfo_RepayAcctType.required = false;
    this.qs_otherinfo_RepayAcctType.tabId = this.tabId;
    this.qs_otherinfo_RepayAcctType.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_RepayAcct = new QuestionEntity(
      "qs_otherinfo_RepayAcct",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_RepayAcct.displayText = "Repayment Account";
    this.qs_otherinfo_RepayAcct.required = false;
    this.qs_otherinfo_RepayAcct.tabId = this.tabId;
    this.qs_otherinfo_RepayAcct.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_RepayAcctName = new QuestionEntity(
      "qs_otherinfo_RepayAcctName",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_RepayAcctName.displayText = "Repayment Account Name";
    this.qs_otherinfo_RepayAcctName.required = false;
    this.qs_otherinfo_RepayAcctName.tabId = this.tabId;
    this.qs_otherinfo_RepayAcctName.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_AutoIssue = new QuestionEntity(
      "qs_otherinfo_AutoIssue",
      undefined,
      Enums.AnswerDataType.Boolean
    );
    this.qs_otherinfo_AutoIssue.displayText = "Auto Issue Flag";
    this.qs_otherinfo_AutoIssue.required = false;
    this.qs_otherinfo_AutoIssue.tabId = this.tabId;
    this.qs_otherinfo_AutoIssue.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_PreGeneratePolicyNo = new QuestionEntity(
      "qs_otherinfo_PreGeneratePolicyNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_PreGeneratePolicyNo.displayText =
      "Pre-generated policy No";
    this.qs_otherinfo_PreGeneratePolicyNo.required = false;
    this.qs_otherinfo_PreGeneratePolicyNo.tabId = this.tabId;
    this.qs_otherinfo_PreGeneratePolicyNo.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_InsuranceOption = new QuestionEntity(
      "qs_otherinfo_InsuranceOption",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_InsuranceOption.displayText = "Insurance Option";
    this.qs_otherinfo_InsuranceOption.required = false;
    this.qs_otherinfo_InsuranceOption.tabId = this.tabId;
    this.qs_otherinfo_InsuranceOption.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_CurrentLoanValue = new QuestionEntity(
      "qs_otherinfo_CurrentLoanValue",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_otherinfo_CurrentLoanValue.displayText = "Current Loan Value";
    this.qs_otherinfo_CurrentLoanValue.required = false;
    this.qs_otherinfo_CurrentLoanValue.tabId = this.tabId;
    this.qs_otherinfo_CurrentLoanValue.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_ProptyReinstaCost = new QuestionEntity(
      "qs_otherinfo_ProptyReinstaCost",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_otherinfo_ProptyReinstaCost.displayText =
      "Property Reinstalling cost";
    this.qs_otherinfo_ProptyReinstaCost.required = false;
    this.qs_otherinfo_ProptyReinstaCost.tabId = this.tabId;
    this.qs_otherinfo_ProptyReinstaCost.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_ProptyReinstaCostDate = new QuestionEntity(
      "qs_otherinfo_ProptyReinstaCostDate",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_otherinfo_ProptyReinstaCostDate.displayText =
      "Date of Property Reinstalling Cost Report";
    this.qs_otherinfo_ProptyReinstaCostDate.required = false;
    this.qs_otherinfo_ProptyReinstaCostDate.tabId = this.tabId;
    this.qs_otherinfo_ProptyReinstaCostDate.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_otherinfo_CustomerSegment = new QuestionEntity(
      "qs_otherinfo_CustomerSegment",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_otherinfo_CustomerSegment.displayText = "Customer Segment";
    this.qs_otherinfo_CustomerSegment.required = false;
    this.qs_otherinfo_CustomerSegment.tabId = this.tabId;
    this.qs_otherinfo_CustomerSegment.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_excess = new QuestionEntity(
      "qs_fire_excess",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_excess.displayText = "Excess";
    this.qs_fire_excess.required = false;
    this.qs_fire_excess.tabId = this.tabId;
    this.qs_fire_excess.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_generalPage = new QuestionEntity(
      "qs_fire_generalPage",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_generalPage.displayText = "General Page";
    this.qs_fire_generalPage.required = false;
    this.qs_fire_generalPage.tabId = this.tabId;
    this.qs_fire_generalPage.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_businessDesc = new QuestionEntity(
      "qs_fire_businessDesc",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_businessDesc.displayText = "Business Description";
    this.qs_fire_businessDesc.required = false;
    this.qs_fire_businessDesc.tabId = this.tabId;
    this.qs_fire_businessDesc.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_interestedParties = new QuestionEntity(
      "qs_fire_interestedParties",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_interestedParties.displayText = "Interested Parties";
    this.qs_fire_interestedParties.required = false;
    this.qs_fire_interestedParties.tabId = this.tabId;
    this.qs_fire_interestedParties.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_discussionNotes = new QuestionEntity(
      "qs_fire_discussionNotes",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_discussionNotes.displayText = "Discussion Note";
    this.qs_fire_discussionNotes.required = false;
    this.qs_fire_discussionNotes.tabId = this.tabId;
    this.qs_fire_discussionNotes.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    // New IBG risk details
    this.qs_fire_natureBusiness = new QuestionEntity(
      "qs_fire_natureBusiness",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_natureBusiness.displayText = "Nature of Business";
    this.qs_fire_natureBusiness.required = false;
    this.qs_fire_natureBusiness.tabId = this.tabId;
    this.qs_fire_natureBusiness.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_usagePremises = new QuestionEntity(
      "qs_fire_usagePremises",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_usagePremises.displayText = "Usage of Premises";
    this.qs_fire_usagePremises.required = false;
    this.qs_fire_usagePremises.tabId = this.tabId;
    this.qs_fire_usagePremises.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_typeProperty = new QuestionEntity(
      "qs_fire_typeProperty",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_typeProperty.displayText = "Type Of Property";
    this.qs_fire_typeProperty.required = true;
    this.qs_fire_typeProperty.tabId = this.tabId;
    this.qs_fire_typeProperty.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_freeInsuranceFirstYear = new QuestionEntity(
      "qs_fire_freeInsuranceFirstYear",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_freeInsuranceFirstYear.displayText =
      "Free Insurance for First Year";
    this.qs_fire_freeInsuranceFirstYear.required = false;
    this.qs_fire_freeInsuranceFirstYear.options = [
      { key: "Yes", value: "1" },
      { key: "No", value: "2" },
    ];
    this.qs_fire_freeInsuranceFirstYear.tabId = this.tabId;
    this.qs_fire_freeInsuranceFirstYear.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_nameSolicitors = new QuestionEntity(
      "qs_fire_nameSolicitors",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_nameSolicitors.displayText =
      "Name of Solicitors (For HDB Shops only)";
    this.qs_fire_nameSolicitors.required = false;
    this.qs_fire_nameSolicitors.tabId = this.tabId;
    this.qs_fire_nameSolicitors.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_machinery_equipment = new QuestionEntity(
      "qs_machinery_equipment",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_machinery_equipment.displayText = "Equipment";
    this.qs_machinery_equipment.required = true;
    this.qs_machinery_equipment.tabId = this.tabId;
    this.qs_machinery_equipment.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_lst = new QuestionEntity(
      "qs_master_lst",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_lst.displayText = "Local Surplus Treaty";
    this.qs_master_lst.required = false;
    this.qs_master_lst.readOnly = true;
    this.qs_master_lst.options = [
      { key: "Yes", value: "1" },
      { key: "No", value: "2" },
    ];
    this.qs_master_lst.tabId = this.tabId;
    this.qs_master_lst.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_lstDetails = new QuestionEntity(
      "qs_master_lstDetails",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_lstDetails.displayText = "LST Details";
    this.qs_master_lstDetails.required = false;
    this.qs_master_lstDetails.tabId = this.tabId;
    this.qs_master_lstDetails.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_fire_equipment_description = new QuestionEntity(
      "qs_fire_equipment_description",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_equipment_description.displayText = "Description of Equipment";
    this.qs_fire_equipment_description.required = false;
    this.qs_fire_equipment_description.tabId = this.tabId;
    this.qs_fire_equipment_description.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_equipment_type = new QuestionEntity(
      "qs_fire_equipment_type",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_equipment_type.displayText = "Type of Equipment";
    this.qs_fire_equipment_type.required = false;
    this.qs_fire_equipment_type.tabId = this.tabId;
    this.qs_fire_equipment_type.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_equipment_financing = new QuestionEntity(
      "qs_fire_equipment_financing",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_equipment_financing.displayText = "Type of Financing";
    this.qs_fire_equipment_financing.required = false;
    this.qs_fire_equipment_financing.tabId = this.tabId;
    this.qs_fire_equipment_financing.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_sumOfInsured = new QuestionEntity(
      "qs_fire_sumOfInsured",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_sumOfInsured.displayText = "Sum Insured";
    this.qs_fire_sumOfInsured.required = false;
    this.qs_fire_sumOfInsured.tabId = this.tabId;
    this.qs_fire_sumOfInsured.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_building = new QuestionEntity(
      "qs_fire_building",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_building.displayText = "Building";
    this.qs_fire_building.required = false;
    this.qs_fire_building.tabId = this.tabId;
    this.qs_fire_building.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_fire_householdContents = new QuestionEntity(
      "qs_fire_householdContents",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_householdContents.displayText = "Household contents";
    this.qs_fire_householdContents.required = false;
    this.qs_fire_householdContents.readOnly = true;
    this.qs_fire_householdContents.tabId = this.tabId;
    this.qs_fire_householdContents.questionPanelId =
      MortgageFireHKSectionSchema.locationInsuredInfo.sectionId;

    this.qs_master_dateOfBirthOrIncorporation = new QuestionEntity(
      "qs_master_dateOfBirthOrIncorporation",
      undefined,
      Enums.AnswerDataType.Date
    );
    this.qs_master_dateOfBirthOrIncorporation.displayText = "Date Of Birth";
    this.qs_master_dateOfBirthOrIncorporation.required = true;
    this.qs_master_dateOfBirthOrIncorporation.readOnly = false;
    this.qs_master_dateOfBirthOrIncorporation.tabId = this.tabId;
    this.qs_master_dateOfBirthOrIncorporation.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    this.qs_master_dateOfBirthOrIncorporation.maxValue = new Date();

    this.qs_master_clientContactPerson = new QuestionEntity(
      "qs_master_clientContactPerson",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_clientContactPerson.displayText = "Client Contact Person";
    this.qs_master_clientContactPerson.required = false;
    this.qs_master_clientContactPerson.readOnly = false;
    this.qs_master_clientContactPerson.tabId = this.tabId;
    this.qs_master_clientContactPerson.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_clientContactPersonContactNo = new QuestionEntity(
      "qs_master_clientContactPersonContactNo",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_clientContactPersonContactNo.displayText =
      "Client Contact Person Contact No";
    this.qs_master_clientContactPersonContactNo.required = false;
    this.qs_master_clientContactPersonContactNo.readOnly = false;
    this.qs_master_clientContactPersonContactNo.tabId = this.tabId;
    this.qs_master_clientContactPersonContactNo.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_machinery_uploadSumInsured = new QuestionEntity(
      "qs_machinery_uploadSumInsured",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_machinery_uploadSumInsured.displayText = "Uploaded Sum Insured";
    this.qs_machinery_uploadSumInsured.required = false;
    this.qs_machinery_uploadSumInsured.readOnly = true;
    this.qs_machinery_uploadSumInsured.tabId = this.tabId;
    this.qs_machinery_uploadSumInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_machinery_uploadTypeOfEquipment = new QuestionEntity(
      "qs_machinery_uploadTypeOfEquipment",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_machinery_uploadTypeOfEquipment.displayText =
      "Uploaded Type Of Equipment";
    this.qs_machinery_uploadTypeOfEquipment.required = false;
    this.qs_machinery_uploadTypeOfEquipment.readOnly = true;
    this.qs_machinery_uploadTypeOfEquipment.tabId = this.tabId;
    this.qs_machinery_uploadTypeOfEquipment.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_machinery_uploadEquipmentDescription = new QuestionEntity(
      "qs_machinery_uploadEquipmentDescription",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_machinery_uploadEquipmentDescription.displayText =
      "Uploaded Equipment Description";
    this.qs_machinery_uploadEquipmentDescription.required = false;
    this.qs_machinery_uploadEquipmentDescription.readOnly = true;
    this.qs_machinery_uploadEquipmentDescription.tabId = this.tabId;
    this.qs_machinery_uploadEquipmentDescription.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_machinery_uploadTypeOfFinancing = new QuestionEntity(
      "qs_machinery_uploadTypeOfFinancing",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_machinery_uploadTypeOfFinancing.displayText =
      "Uploaded Type Of Financing";
    this.qs_machinery_uploadTypeOfFinancing.required = false;
    this.qs_machinery_uploadTypeOfFinancing.readOnly = true;
    this.qs_machinery_uploadTypeOfFinancing.tabId = this.tabId;
    this.qs_machinery_uploadTypeOfFinancing.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_uploadAdditionalInsured = new QuestionEntity(
      "qs_master_uploadAdditionalInsured",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_uploadAdditionalInsured.displayText =
      "Uploaded Additional Insured";
    this.qs_master_uploadAdditionalInsured.required = false;
    this.qs_master_uploadAdditionalInsured.readOnly = true;
    this.qs_master_uploadAdditionalInsured.tabId = this.tabId;
    this.qs_master_uploadAdditionalInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_fire_freeInsuranceNoYear = new QuestionEntity(
      "qs_fire_freeInsuranceNoYear",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_fire_freeInsuranceNoYear.displayText =
      "No. of Years – Free Insurance";
    this.qs_fire_freeInsuranceNoYear.required = false;
    this.qs_fire_freeInsuranceNoYear.answer = 0;
    this.qs_fire_freeInsuranceNoYear.tabId = this.tabId;
    this.qs_fire_freeInsuranceNoYear.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredNo2 = new QuestionEntity(
      "qs_master_insuredNo2",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNo2.displayText =
      "Business Registeration No / NRIC - 2nd Insured";
    this.qs_master_insuredNo2.required = false;
    this.qs_master_insuredNo2.readOnly = true;
    this.qs_master_insuredNo2.tabId = this.tabId;
    this.qs_master_insuredNo2.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    this.qs_master_insuredNo2.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredNo2Nationality = new QuestionEntity(
      "qs_master_insuredNo2Nationality",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNo2Nationality.displayText = "Nationality";
    this.qs_master_insuredNo2Nationality.required = false;
    this.qs_master_insuredNo2Nationality.readOnly = false;
    this.qs_master_insuredNo2Nationality.tabId = this.tabId;
    this.qs_master_insuredNo2Nationality.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_insuredNo2DocType = new QuestionEntity(
      "qs_master_insuredNo2DocType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_insuredNo2DocType.displayText = "Document Type";
    this.qs_master_insuredNo2DocType.required = false;
    this.qs_master_insuredNo2DocType.readOnly = false;
    this.qs_master_insuredNo2DocType.tabId = this.tabId;
    this.qs_master_insuredNo2DocType.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
    this.qs_master_insuredNo2DocType.options = [
      { key: "S - Singapore NRIC", value: "1" },
      { key: "S - Singapore PR", value: "2" },
      { key: "M - Malaysia IC", value: "3" },
      { key: "P - Foreign Passport", value: "4" },
    ];

    this.qs_master_namesOtherInsured = new QuestionEntity(
      "qs_master_namesOtherInsured",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_master_namesOtherInsured.displayText = "Names other than Insured";
    this.qs_master_namesOtherInsured.required = false;
    this.qs_master_namesOtherInsured.tabId = this.tabId;
    this.qs_master_namesOtherInsured.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_borrowerCIN = new QuestionEntity(
      "qs_master_borrowerCIN",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_master_borrowerCIN.displayText = "Borrower GCIN";
    this.qs_master_borrowerCIN.required = false;
    this.qs_master_borrowerCIN.tabId = this.tabId;
    this.qs_master_borrowerCIN.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.masterDataService.getNationalityList().subscribe((response) => {
      this.nationalityList = response;
      this.qs_master_insuredNoNationality!.options = this.nationalityList;
      this.qs_master_insuredNo2Nationality!.options = this.nationalityList;
    });

    this.qs_master_premiumPayment = new QuestionEntity(
      "qs_master_premiumPayment",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_premiumPayment.displayText = "Premium Payment";
    this.qs_master_premiumPayment.required = false; //no needed for Hase
    this.qs_master_premiumPayment.tabId = this.tabId;
    this.qs_master_premiumPayment.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_customerType = new QuestionEntity(
      "qs_master_customerType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_customerType.displayText = "Customer Type";
    this.qs_master_customerType.required = true;
    this.qs_master_customerType.tabId = this.tabId;
    this.qs_master_customerType.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_collateralNumber = new QuestionEntity(
      "qs_master_collateralNumber",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_collateralNumber.displayText = "Collateral No";
    this.qs_master_collateralNumber.required = true;
    this.qs_master_collateralNumber.tabId = this.tabId;
    this.qs_master_collateralNumber.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_discountCode = new QuestionEntity(
      "qs_master_discountCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_discountCode.displayText = "Code";
    this.qs_master_discountCode.required = false;
    this.qs_master_discountCode.tabId = this.tabId;
    this.qs_master_discountCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_fire_outstandingLoanValue = new QuestionEntity(
      "qs_fire_outstandingLoanValue",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_outstandingLoanValue.displayText = "Outstanding Loan Value";
    this.qs_fire_outstandingLoanValue.required = false;
    this.qs_fire_outstandingLoanValue.tabId = this.tabId;
    this.qs_fire_outstandingLoanValue.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_fire_coverageValueType = new QuestionEntity(
      "qs_fire_coverageValueType",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_fire_coverageValueType.displayText = "Coverage Value Type";
    this.qs_fire_coverageValueType.required = true;
    this.qs_fire_coverageValueType.tabId = this.tabId;
    this.qs_fire_coverageValueType.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_customDiscountCode = new QuestionEntity(
      "qs_master_customDiscountCode",
      undefined,
      Enums.AnswerDataType.Numeric
    );
    this.qs_master_customDiscountCode.displayText = "Custom Code";
    this.qs_master_customDiscountCode.required = false;
    this.qs_master_customDiscountCode.tabId = this.tabId;
    this.qs_master_customDiscountCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_risk_occupancy = new QuestionEntity(
      "qs_risk_occupancy",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_occupancy.displayText = "Occupancy";
    this.qs_risk_occupancy.required = false;
    this.qs_risk_occupancy.tabId = this.tabId;
    this.qs_risk_occupancy.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_risk_construction = new QuestionEntity(
      "qs_risk_construction",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_risk_construction.displayText = "Construction";
    this.qs_risk_construction.required = false;
    this.qs_risk_construction.tabId = this.tabId;
    this.qs_risk_construction.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.initHaseQuestions();
  }

  initHaseQuestions() {
    this.qs_master_rmBranchCode = new QuestionEntity(
      "qs_master_rmBranchCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmBranchCode.displayText = "Branch Code";
    this.qs_master_rmBranchCode.maxLength = 100;
    this.qs_master_rmBranchCode.required = false;
    this.qs_master_rmBranchCode.tabId = this.tabId;
    this.qs_master_rmBranchCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmMortgageeCode = new QuestionEntity(
      "qs_master_rmMortgageeCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmMortgageeCode.displayText = "Mortgagee Code";
    this.qs_master_rmMortgageeCode.maxLength = 100;
    this.qs_master_rmMortgageeCode.required = false;
    this.qs_master_rmMortgageeCode.tabId = this.tabId;
    this.qs_master_rmMortgageeCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmSalesChannel = new QuestionEntity(
      "qs_master_rmSalesChannel",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmSalesChannel.displayText = "Sales Channel";
    this.qs_master_rmSalesChannel.maxLength = 100;
    this.qs_master_rmSalesChannel.required = false;
    this.qs_master_rmSalesChannel.tabId = this.tabId;
    this.qs_master_rmSalesChannel.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmStaffReference = new QuestionEntity(
      "qs_master_rmStaffReference",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmStaffReference.displayText = "HASE Staff Reference";
    this.qs_master_rmStaffReference.maxLength = 100;
    this.qs_master_rmStaffReference.required = false;
    this.qs_master_rmStaffReference.tabId = this.tabId;
    this.qs_master_rmStaffReference.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;


      this.qs_master_internalReference = new QuestionEntity(
      "qs_master_internalReference",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_internalReference.displayText = "Internal Reference";
    this.qs_master_internalReference.maxLength = 1000;
    this.qs_master_internalReference.required = false;
    this.qs_master_internalReference.tabId = this.tabId;
    this.qs_master_internalReference.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_notRenew = new QuestionEntity(
      "qs_master_notRenew",
      undefined,
      Enums.AnswerDataType.Boolean
    );
    this.qs_master_notRenew.displayText = "Not Renew";
    this.qs_master_notRenew.required = false;
    this.qs_master_notRenew.tabId = this.tabId;
    this.qs_master_notRenew.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;

    this.qs_master_rmSalesStaffCode = new QuestionEntity(
      "qs_master_rmSalesStaffCode",
      undefined,
      Enums.AnswerDataType.String
    );
    this.qs_master_rmSalesStaffCode.displayText = "HASE Sales Staff Code";
    this.qs_master_rmSalesStaffCode.maxLength = 100;
    this.qs_master_rmSalesStaffCode.required = false;
    this.qs_master_rmSalesStaffCode.tabId = this.tabId;
    this.qs_master_rmSalesStaffCode.questionPanelId =
      MortgageFireHKSectionSchema.master.sectionId;
  }

  refreshQuestionsArray() {
    this.questions = [];
    this.questions.push(this.qs_master_brokerFirstName!);
    this.questions.push(this.qs_master_brokerLastName!);
    this.questions.push(this.qs_master_brokerOrganizationName!);

    this.questions.push(this.qs_master_insuredNo!);
    this.questions.push(this.qs_master_insuredNoNationality!);
    this.questions.push(this.qs_master_insuredNoDocType!);
    this.questions.push(this.qs_master_insuredName!);
    this.questions.push(this.qs_master_replacePolicyNo!);
    this.questions.push(this.qs_master_masterPolicyNumber!);
    this.questions.push(this.qs_master_planType!);
    this.questions.push(this.qs_master_poi_startDate!);
    this.questions.push(this.qs_master_poi_endDate!);

    //// 12/10/2018 : Chirag Added Code For FreeInsurance Start/End Date
    this.questions.push(this.qs_master_FreeIns_startDate!);
    this.questions.push(this.qs_master_FreeIns_endDate!);

    this.questions.push(this.qs_master_financialBranch!);
    this.questions.push(this.qs_master_bankReferNumber!);
    this.questions.push(this.qs_master_assetClassCode!);
    this.questions.push(this.qs_master_assetSerialNumber!);
    this.questions.push(this.qs_master_effectiveDate!);

    this.questions.push(this.qs_location_occupation!);
    this.questions.push(this.qs_location_riskAddress1!);
    this.questions.push(this.qs_location_riskAddress2!);

    this.questions.push(this.qs_risk_floating!);
    this.questions.push(this.qs_risk_sameAsAddress!);
    this.questions.push(this.qs_risk_insuredAddress_building!);
    this.questions.push(this.qs_risk_insuredAddress_lotunit!);
    this.questions.push(this.qs_risk_insuredAddress1!);
    this.questions.push(this.qs_risk_insuredAddress2!);
    this.questions.push(this.qs_risk_insuredAddress3!);
    this.questions.push(this.qs_risk_insuredDistCode!);
    this.questions.push(this.qs_risk_insuredPostalCode!);
    this.questions.push(this.qs_risk_insuredCity!);
    this.questions.push(this.qs_risk_insuredState!);
    this.questions.push(this.qs_risk_insuredCountry!);

    //// 24/01/2019 : Chirag Added Code For Mobile/Email
    ////DBSEP-252 : Client Info Update
    this.questions.push(this.qs_master_preferredDeliveryMethod_Email!);
    this.questions.push(this.qs_master_preferredDeliveryMethod_MobileNo!);
    this.questions.push(this.qs_master_preferredDeliveryMethod_CorrAddress!);
    this.questions.push(this.qs_master_mobileNumber!);
    this.questions.push(this.qs_master_emailID!);
    this.questions.push(this.qs_master_salutation!);
    this.questions.push(this.qs_master_clientName!);
    this.questions.push(this.qs_master_passport!);
    this.questions.push(this.qs_master_nric!);
    this.questions.push(this.qs_master_occupation!);
    this.questions.push(this.qs_master_birthDate!);
    this.questions.push(this.qs_master_race!);
    this.questions.push(this.qs_master_nationality!);
    this.questions.push(this.qs_master_gender!);
    this.questions.push(this.qs_master_maritalStatus!);
    this.questions.push(this.qs_master_phoneNoHome!);
    this.questions.push(this.qs_master_phoneNoOffice!);
    this.questions.push(this.qs_master_faxNumber!);
    this.questions.push(this.qs_master_cin!);
    this.questions.push(this.qs_master_preferredDeliveryMethod!);
    this.questions.push(this.qs_master_insuredAddress_building!);
    this.questions.push(this.qs_master_insuredAddress_lotunit!);
    this.questions.push(this.qs_master_insuredAddress1!);
    this.questions.push(this.qs_master_insuredAddress2!);
    this.questions.push(this.qs_master_insuredAddress3!);
    this.questions.push(this.qs_master_insuredAddress4!);
    this.questions.push(this.qs_master_insuredPostalCode!);
    this.questions.push(this.qs_master_insuredCity!);
    this.questions.push(this.qs_master_insuredState!);
    this.questions.push(this.qs_master_insuredCountry!);

    // this.questions.push(this.qs_fire_situation);
    this.questions.push(this.qs_fire_occupied!);
    this.questions.push(this.qs_master_miRate!);
    this.questions.push(this.qs_fire_notes!);
    this.questions.push(this.qs_fire_excess!);
    this.questions.push(this.qs_fire_mcst!);
    this.questions.push(this.qs_fire_replacement!);
    this.questions.push(this.qs_fire_generalPage!);
    this.questions.push(this.qs_fire_businessDesc!);
    this.questions.push(this.qs_fire_interestedParties!);
    this.questions.push(this.qs_fire_discussionNotes!);

    // New IBG fields
    this.questions.push(this.qs_master_buPcCode!);
    this.questions.push(this.qs_master_uploadBuPcCode!);
    this.questions.push(this.qs_master_busReg1stInsured!);
    this.questions.push(this.qs_master_busReg2ndInsured!);
    this.questions.push(this.qs_master_additionalInsured!);
    this.questions.push(this.qs_master_otherInsuredName!);
    this.questions.push(this.qs_master_rmName!);
    this.questions.push(this.qs_master_rmContactNo!);
    this.questions.push(this.qs_master_rmRemarks!);
    this.questions.push(this.qs_master_insuredAddress!);
    this.questions.push(this.qs_master_insuredNo2!);
    this.questions.push(this.qs_master_insuredNo2Nationality!);
    this.questions.push(this.qs_master_insuredNo2DocType!);
    this.questions.push(this.qs_master_namesOtherInsured!);
    this.questions.push(this.qs_master_borrowerCIN!);

    this.questions.push(this.qs_fire_natureBusiness!);
    this.questions.push(this.qs_fire_usagePremises!);
    this.questions.push(this.qs_fire_typeProperty!);
    this.questions.push(this.qs_fire_freeInsuranceFirstYear!);
    this.questions.push(this.qs_fire_nameSolicitors!);
    this.questions.push(this.qs_fire_equipment_description!);
    this.questions.push(this.qs_fire_equipment_type!);
    this.questions.push(this.qs_fire_equipment_financing!);
    this.questions.push(this.qs_fire_sumOfInsured!);
    this.questions.push(this.qs_fire_building!);
    this.questions.push(this.qs_fire_householdContents!);
    this.questions.push(this.qs_machinery_equipment!);
    this.questions.push(this.qs_risk_uploadRiskAddress!);
    this.questions.push(this.qs_master_endorse_endorsementReason!);
    this.questions.push(this.qs_master_refund!);
    this.questions.push(this.qs_master_waiveMinimumPremium!);
    this.questions.push(this.qs_master_cancellation_masterpiece!);
    this.questions.push(this.qs_master_cancellation_maximumAdjustmentAmount!);
    this.questions.push(this.qs_master_cancellation_adjustmentAmount!);
    this.questions.push(this.qs_master_insuredIndustry!);
    this.questions.push(this.qs_master_occupancyRate!);
    this.questions.push(this.qs_master_insuredIndustry_desc!);

    this.questions.push(this.qs_master_dateOfBirthOrIncorporation!);
    this.questions.push(this.qs_master_clientContactPerson!);
    this.questions.push(this.qs_master_clientContactPersonContactNo!);
    this.questions.push(this.qs_machinery_uploadSumInsured!);
    this.questions.push(this.qs_machinery_uploadTypeOfEquipment!);
    this.questions.push(this.qs_machinery_uploadEquipmentDescription!);
    this.questions.push(this.qs_machinery_uploadTypeOfFinancing!);
    this.questions.push(this.qs_fire_freeInsuranceNoYear!);
    this.questions.push(this.qs_master_uploadAdditionalInsured!);

    this.questions.push(this.qs_master_lst!);
    this.questions.push(this.qs_master_lstDetails!);

    this.questions.push(this.qs_master_manualUnderwritting!);

    //Citi
    this.questions.push(this.qs_master_premiumPayment!);
    this.questions.push(this.qs_master_customerType!);
    this.questions.push(this.qs_master_collateralNumber!);
    this.questions.push(this.qs_master_discountCode!);
    this.questions.push(this.qs_fire_outstandingLoanValue!);
    this.questions.push(this.qs_fire_coverageValueType!);
    this.questions.push(this.qs_master_customDiscountCode!);

    //Hase
    this.questions.push(this.qs_risk_carParkAddress1!);
    this.questions.push(this.qs_risk_carParkAddress2!);
    this.questions.push(this.qs_risk_carParkAddress3!);
    this.questions.push(this.qs_risk_carParkAddress4!);
    this.questions.push(this.qs_risk_carParkCountry!);
    this.questions.push(this.qs_fire_grossFloorArea!);
    this.questions.push(this.qs_fire_loanAmount!);
    this.questions.push(this.qs_fire_currency!);
    this.questions.push(this.qs_fire_freeInsurance!);
    this.questions.push(this.qs_risk_occupancy!);
    this.questions.push(this.qs_risk_construction!);

    this.questions.push(this.qs_master_rmBranchCode!);
    this.questions.push(this.qs_master_rmMortgageeCode!);
    this.questions.push(this.qs_master_rmSalesChannel!);
    this.questions.push(this.qs_master_rmStaffReference!);
    this.questions.push(this.qs_master_internalReference!);
    this.questions.push(this.qs_master_notRenew!);
    this.questions.push(this.qs_master_rmSalesStaffCode!);

    //Hase "Other Information" Section
    this.questions.push(this.qs_otherinfo_MortgLoanAcctNum1!);
    this.questions.push(this.qs_otherinfo_MortgLoanAcctNum2!);
    this.questions.push(this.qs_otherinfo_MortgLoanAcctNum3!);
    this.questions.push(this.qs_otherinfo_InsuranceCompany!);
    this.questions.push(this.qs_otherinfo_VersionDate!);
    this.questions.push(this.qs_otherinfo_MortgLoanRecEntryDate!);
    this.questions.push(this.qs_otherinfo_RepayAcctType!);
    this.questions.push(this.qs_otherinfo_RepayAcct!);
    this.questions.push(this.qs_otherinfo_RepayAcctName!);
    this.questions.push(this.qs_otherinfo_AutoIssue!);
    this.questions.push(this.qs_otherinfo_PreGeneratePolicyNo!);
    this.questions.push(this.qs_otherinfo_InsuranceOption!);
    this.questions.push(this.qs_otherinfo_CurrentLoanValue!);
    this.questions.push(this.qs_otherinfo_ProptyReinstaCost!);
    this.questions.push(this.qs_otherinfo_ProptyReinstaCostDate!);
    this.questions.push(this.qs_otherinfo_CustomerSegment!);
  }
}
